<template>
  <div class="recharge">
    <div class="div-block">
      <div class="title">余额充值</div>
      <div class="input">
        ¥
        <input type="number" v-model="rechargePrice" :placeholder="`请输入充值金额（${dataObj.min > 0 ? dataObj.min : 0} ~ ${dataObj.max > 0 ? dataObj.max : 0})`" class="input-txt">
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in lists" :key="index" @click="handleChangeItem(index)"
          :class="curItemIndex === index ? 'cur' : ''">{{ item }}</div>
      </div>
    </div>
    <div class="div-block">
      <div class="pay-title">支付方式</div>
      <div class="pay-item">
        <img src="@/assets/images_member/icon122.png" class="item-icon" alt="">
        <div class="item-txt">微信支付</div>
        <img src="@/assets/images_member/icon113.png" class="icon-check" alt="">
      </div>
    </div>
    <div class="fixed-btn">
      <img src="@/assets/images_member/Group 494@2x 2.png"  class="icon-zixun" @click="dialog = !dialog" alt="">
      <div class="btn-txt" @click="handleSubmit">立即充值 ¥{{ rechargePrice > 0 ? rechargePrice : 0 }}</div>
    </div>
    <CustomerService :dialog="dialog"></CustomerService>
    <van-overlay :show="click">
      <van-loading type="spinner"/>
    </van-overlay>
  </div>
</template>
<script>
import { rechargeGetList, rechargePost } from '@/api/person'
import CustomerService from '@/components/CustomerService.vue'
import { handlePay } from '@/utils/wxConfig'
export default {
  name: 'recharge',
  components: {
    CustomerService
  },
  data () {
    return {
      lists: [],
      curItemIndex: '',
      rechargePrice: '',
      dialog: false,
      dataObj: {},
      click: false
    }
  },
  computed: {
    thirdUserInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_third-user-info']).value
    },
  },
  mounted () {
    this.handleFunc()
  },
  methods: {
    handleFunc () {
      rechargeGetList().then(res => {
        this.lists = res.data.lists
        this.dataObj = res.data
      })
    },
    handleSubmit () {
      var ua = navigator.userAgent.toLowerCase()
      var weixin = ua.indexOf('micromessenger') !== -1
      console.log(weixin)
      if (!weixin) {
        console.log('666')
        this.$toast('请到微信公众号“幸福公社”去充值！')
        return false
      }
      if (this.click) {
        this.$toast('支付中...')
        return
      }
      if (this.rechargePrice <= 0) {
        this.$toast('请输入充值余额')
        return
      } else if (this.rechargePrice > this.lists[this.lists.length - 1]) {
        this.$toast(`充值余额不能大于${this.lists[this.lists.length - 1]}`)
        return
      }
      let params = {
        price: this.rechargePrice,
        openid: this.thirdUserInfo.openid,
        toPage: `https://vip.xf-market.com/rechargeSuccess?price=${this.rechargePrice}`
      }
      rechargePost(params).then(res => {
        setTimeout(() => {
          this.click = false
        }, 500)
        handlePay(res)
      })
    },
    handleChangeItem (index) {
      this.curItemIndex = index
      this.rechargePrice = this.lists[index]
    }
  }
}
</script>

<style lang="less" scoped>
.recharge {
  padding: 14px;
  box-sizing: border-box;
  background-color: #1E2020;
  padding-bottom: 80px;
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;

  .div-block {
    border-radius: 10px;
    background-color: #2F3131;
    padding: 0 10px;
    box-sizing: border-box;
    margin-bottom: 14px;

    .title {
      height: 58px;
      line-height: 58px;
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 600;
    }

    .input {
      display: flex;
      align-items: center;
      border-radius: 6px;
      background-color: #1E2020;
      font-size: 20px;
      color: #F0E1C0;
      font-weight: 600;
      height: 56px;
      padding-left: 14px;
      box-sizing: border-box;

      .input-txt {
        font-size: 26px;
        color: #F0E1C0;
        line-height: 56px;
        outline: none;
        background-color: transparent;
        border: none;
        flex: 1;
        margin-left: 10px;

        &::placeholder {
          color: #999999;
          font-size: 14px;
          position: relative;
          top: -3px;
        }
      }
    }

    .list {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 10px;
      box-sizing: box-sizing;

      .item {
        width: 102px;
        height: 80px;
        border-radius: 6px;
        background-color: #1E2020;
        margin-bottom: 10px;
        display: flex;
        align-items: baseline;
        justify-content: center;
        line-height: 80px;
        color: #999999;
        font-size: 26px;
        font-weight: 600;

        &.cur {
          background-color: #F0E1C0;
          color: #504632;
        }

        &::before {
          font-size: 14px;
          content: "￥";
        }
      }
    }

    .pay-title {
      font-size: 14px;
      color: #FFFFFF;
      font-weight: 600;
      line-height: 14px;
      margin-bottom: 24px;
      padding-top: 20px;
      box-sizing: border-box;
    }

    .pay-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 20px;
      box-sizing: border-box;

      .item-icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }

      .item-txt {
        font-size: 14px;
        color: #18BB08;
        font-weight: 500;
        flex: 1;
      }

      .icon-check {
        width: 20px;
        height: 20px;
      }
    }
  }

  .fixed-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 66px;
    padding: 9px 14px;
    box-sizing: border-box;
    background-color: #2F3131;
    display: flex;
    align-items: center;

    .icon-zixun {
      width: 34px;
      margin-right: 14px;
    }

    .btn-txt {
      flex: 1;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 100px;
      background-color: #F0E1C0;
      color: #504632;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/recharge.vue